import { push } from 'connected-react-router';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { resolveApiCall } from '../../services/api-handlers/api-resolver';
import UserAuthService from '../../services/user-auth';
import { AuthApi } from '../../services/end-points';
import Router from '../../navigation/router';
import routes from '../../navigation/routes';
import { LoginFormData } from '../../screens/Auth/screens/Login/components/LoginForm';
import { makeFormErrors } from '../../components/react-hook-form/utils/make-form-errors';
import { ThunkConfig } from '../configure-store';

export const login = createAsyncThunk<void, LoginFormData, ThunkConfig>(
    'auth/login',
    async ({ email, password }, thunkAPI) => {
        const { dispatch, getState } = thunkAPI;
        const { auth } = getState();

        return resolveApiCall(
            thunkAPI,
            auth,
            async () => {
                const { data } = await AuthApi.login(email, password);
                await UserAuthService.login(data.token, data.refreshToken);
                dispatch(push(Router.generate(routes.HOME)));
            },
            async (err) => {
                const { response } = err;
                return makeFormErrors<LoginFormData>({
                    _error: response?.status < 500 ? 'Incorrect email or password' : 'Something went wrong',
                });
            },
        );
    },
);

export const logout = createAsyncThunk<void, void, ThunkConfig>('auth/logout', async (payload, thunkAPI) => {
    const { dispatch } = thunkAPI;
    await UserAuthService.logout();
    dispatch(push(Router.generate(routes.LOGIN)));
});
